import { render, staticRenderFns } from "./DiscountSettings.vue?vue&type=template&id=7aaa9fe4&"
import script from "./DiscountSettings.vue?vue&type=script&lang=js&"
export * from "./DiscountSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports